export const altinSponsorlar = [
  {
    id: 1,
    name: "Aselsan",
    imageUrl: "/assets/sponsorlar/altin/aselsan.png",
    url: "https://www.aselsan.com/tr"
  },
  {
    id: 1,
    name: "Damsan",
    imageUrl: "/assets/sponsorlar/altin/damsan.png",
    url: "https://www.damsanmakina.com/"
  },
  {
    id: 1,
    name: "Kefeli Ambalaj",
    imageUrl: "/assets/sponsorlar/altin/kefeli.png",
    url: "https://www.kefeliambalaj.com.tr/"
  },
  {
    id: 2,
    name: "Özyılmaz Fındık",
    imageUrl: "/assets/sponsorlar/altin/ozyilmaz.png",
    url: "https://www.ozyilmazfindik.com/"
  },

  //{
  //  id: 3,
  //  name: "Polfisan",
  //  imageUrl: "/assets/sponsorlar/altin/polfisan.png",
  //  url: "https://www.polfisan.com.tr/"
  //},

  {
    id: 4,
    name: "Samsun Çarşı",
    imageUrl: "/assets/sponsorlar/altin/carsi.png",
    url: "https://www.samsuncarsi.com.tr/"
  },
  {
    id: 4,
    name: "Samsun Ticaret Borsası",
    imageUrl: "/assets/sponsorlar/altin/sam-tic-borsasi.png",
    url: "https://www.samsuntb.org.tr/"
  }
]